<template>
    <div class="main mt15">
        <div class="banner" @click="toBuy" ref="info">
            <img src="/static/images/haierProduct/yunlifang/banner.jpg" alt="">
            <div class="banner-container">
                <!-- <div class="banner-container-title">企业团体雇主责任保险</div>
			<div class="banner-container-case">—  老板事业的护身符  —</div>
			<div class="banner-container-sub">
				<Icon type="md-checkmark-circle" color="#318af0"/> <span>雇主意外</span>
				<Icon type="md-checkmark-circle" color="#318af0"/> <span>职业病</span>
				<Icon type="md-checkmark-circle" color="#318af0"/> <span>误工津贴</span>
			</div> -->
                <div class="banner-container-btn">
                    <a class="btn" @click="toBuy">立即购买</a>
                </div>
            </div>
        </div>
        <div class="tabs" ref="tabs">
            <div class="tabs-container" :class="{fixed:fixed}">
                <Tabs :value="tabName" @on-click="tabChange">
                    <TabPane label="团体意外险" name="info"></TabPane>
                    <TabPane label="安装工程一切险" name="case"></TabPane>
                    <!-- <TabPane label="常见问题" name="question"></TabPane>
				<TabPane label="理赔流程" name="claim"></TabPane> -->
                </Tabs>
                <div class="tabs-container-form" v-show="fixed">
                    <Button type="primary" @click="toBuy">立即购买</Button>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">团体意外险</div>
            <div class="detail-main">
                <div class="detail-main-title">保险方案</div>
                <table class="employerTable" cellspacing="0" cellpadding="0" border="0">
                    <thead>
                        <tr>
                            <th>保障内容</th>
                            <th>赔偿限额</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>身故伤残</td>
                            <td>50万元</td>
                        </tr>
                        <tr>
                            <td>意外医疗</td>
                            <td>5万元</td>
                        </tr>
                        <tr>
                            <td>误工费</td>
                            <td>100元/天（误工费免赔5天，最高赔付180天）</td>
                        </tr>
                        <tr>
                            <td>保费</td>
                            <td>3元/平米</td>
                        </tr>
                    </tbody>
                </table>
                <div class="detail-main-title">特别约定：</div>
                <div class="detail-main-text" ref="case">
                    <p>1、本保单适用《中路财产保险股份有限公司建筑施工人员团体意外伤害保险条款》，同一工程在同一保险期间内，限投保一份，多投保无效。</p>
                    <p>2、本保单下承保员工年龄限制为16-65周岁。</p>
                    <p>3、本保单仅承保纯个人家庭住宅的室内装修工程；对商用写字楼、商铺、厅堂馆所及开发商未售出交付的住宅装修的室内装修工程以及其他广告招牌制安、展台搭建、外墙施工、空调安装、电梯安装、钢结构工程、维修整改工程、幕墙工程等其他类型的安装工程不承保任何保险责任。</p>
                    <p>4、本保单承保的工程项目如出现非法转包行为，保险人不承担保险责任。</p>
                    <p>5、施工员工从事高处作业时因未系绑安全带导致的保险事故属除外责任。当坠落高度距离基准面在2米及2米以上时，该项作业即称为高空（高处）作业；除高处作业外，其他未取得对应的特种作业证书进行特种作业操作引起的意外事故，保险公司不承担保险责任，特种作业定义以《特种作业人员安全技术培训考核管理规定》为准。</p>
                    <p>6、除首次紧急治疗情况外，受伤雇员均应在二级或二级以上的公立医院就诊（不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构）。受伤雇员在得到紧急治疗情况稳定后应转移至二级或二级以上的公立医院继续就诊。
                    </p>
                    <p>7、本保单住院津贴以100元/人/天作为标准计算赔偿金额，免赔5天，最长赔付180天。</p>
                    <p>8、兹经合同双方同意，被保险人必须在知道或应当知道保险事故发生后的48小时内（或保单约定的时间内）向保险人报案，因延迟报案影响保险人查勘、定损的，保险人对于无法核实的部分不承担赔偿责任。</p>
                    <p>9、伤残定残采用《人身保险伤残评定标准及代码》（标准编号为JR/T0083-2013）是由原中国保险监督管理委员会发布（保监发〔2014〕6号）并经国家标准化委员会备案的中华人民共和国金融行业标准。</p>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">安装工程一切险</div>
            <div class="detail-main">
                <div class="detail-main-title">保障内容</div>
                <table class="employerTable" cellspacing="0" cellpadding="0" border="0">
                    <thead>
                        <tr>
                            <th>保障项目</th>
                            <th colspan="2">内容详解</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>保障内容及免赔</td>
                            <td colspan="2" style="padding: 10px;">
                                1、	因本保险合同责任免除以外的任何自然灾害或意外事故造成的物质损坏或损失，以及本保险合同所承保工程直接相关的意外事故引起工地内及邻近区域的第三者人身伤亡或财产损失<br />
                                2、	免赔条件：每次事故财产损失绝对免赔额为1000元或损失金额的20%，两者以高者为准；第三者人伤每次事故绝对免赔额为1000元。
                            </td>
                        </tr>
                        <tr>
                            <td>赔偿限额</td>
                            <td>可选方案</td>
                            <td>保费</td>
                        </tr>
                        <tr>
                            <td rowspan="3">本保单物质损失保险金额和第三者责任赔偿限额共计30/40/50万元可选，其中第三者人身伤亡每次事故医疗赔偿限额不超过10万元。</td>
                            <td>物质损失金额和第三者责任赔偿限额共计30万元</td>
                            <td>150元/单</td>
                        </tr>
                        <tr>
                            <td>物质损失金额和第三者责任赔偿限额共计40万元</td>
                            <td>200元/单</td>
                        </tr>
                        <tr>
                            <td>物质损失金额和第三者责任赔偿限额共计50万元</td>
                            <td>250元/单</td>
                        </tr>
                    </tbody>
                </table>
                <div class="detail-main-title">特别约定</div>
                <div class="detail-main-text" ref="adv">
                    <p>1、本保单适用《中路财产保险股份有限公司安装工程一切险条款》，同一工程在同一保险期间内，限投保一份，多投保无效。</p>
                    <p>2、本保单适用工程：室内装修合同造价30/40/50万以内，工程物质损失部分的赔偿限额以保额或工程承包合同造价金额中的低者为准，出险时如保额不足比例赔付。</p>
                    <p>3、本保单承保项目为云立方签约装饰公司并具有相应营业资质及执照证件的合约项目，不承保个人承包施工业务。承保的工程项目如出现非法转包行为，保险人不承担保险责任。</p>
                    <p>4、本保单仅承保纯个人家庭住宅的室内装修工程；对商用写字楼、商铺、厅堂馆所及开发商未售出交付的住宅装修的室内装修工程以及其他广告招牌制安、展台搭建、外墙施工、空调安装、电梯安装、钢结构工程、维修整改工程、幕墙工程等其他类型的安装工程不承保任何保险责任；</p>
                    <p>5、理赔时需提供包括并不限于原装修合同/施工合同、合作协议、施工终止证明、消防或公安事故证明等材料，具体以保险人理赔要求为准。</p>
                    <p>6、兹经合同双方同意，被保险人必须在知道或应当知道保险事故发生后的48小时内（或保单约定的时间内）向保险人报案，因延迟报案影响保险人查勘、定损的，保险人对于无法核实的部分不承但保险责任。</p>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title" style="margin-bottom: 30px;">我们的优势</div>
            <div class="detail-main-text">
                <p>1、专属渠道场景化定制产品，价格优势明显，性价比高。</p>
                <p>2、按单投保，家装行业首创，按单保费精准对应到每个项目，可将保费计入项目成本；按单收费，有效分化一次性投保的资金压力。</p>
                <p>3、线上投保线上出单，方便快捷，数据透明。</p>
                <p>4、专业保险经纪顾问提供保前咨询、投保出单、协助理赔等全流程服务，有效降低客户直面保险公司时的矛盾。</p>
            </div>
        </div>
        <div class="detail" ref="claim">
            <div class="detail-title">保险理赔</div>
            <div style="line-height: 3;text-align: center;">我们为每位客户配置专业理赔服务经理，全流程协助理赔。</div>
            <Steps class="mt30">
                <Step title="拨打报案电话" status="process" content="出险后请立即拨打报案电话18766426120进行报案，详述出险情况。"></Step>
                <Step title="提交索赔资料" status="process" content="根据理赔服务经理指导提交索赔所需的资料。"></Step>
                <Step title="结案领取赔款" status="process" content="保险公司核定损失，确定赔偿金额，按照约定赔付方式支付赔款。"></Step>
            </Steps>
            <br>
            <br>
        </div>
        <Modal v-model="wangdian.show" title="本次投保险种" :mask-closable="false"
            @on-visible-change="handleReset('wangdianForm')">
            <Form :label-width="110" :model="wangdian.form" ref="wangdianForm">
                <Form-item label="可选方案：">
                    <Checkbox v-model="wangdian.form.singleO">团体意外险</Checkbox>
                </Form-item>
                <Form-item label="可选方案：">
                    <Checkbox v-model="wangdian.form.single">安装工程一切险</Checkbox>
                    <br>
                    <RadioGroup v-model="wangdian.form.eariProductCode" v-if="wangdian.form.single">
                        <Radio label="ERECTION_ALL_1">30万</Radio>
                        <Radio label="ERECTION_ALL_2">40万</Radio>
                        <Radio label="ERECTION_ALL_3">50万</Radio>
                    </RadioGroup>
                </Form-item>
            </Form>
            <div slot="footer">
                <Button @click="wangdian.show = false" type="default">取消</Button>
                <Button @click="bindWangdian()" type="primary">确定</Button>
            </div>
        </Modal>
        <TrackNotice />
    </div>
</template>
<script>
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
	components:{ TrackNotice },
	mixins:[ track ],
        data () {
            return {
                wangdian: {
                    form: {},
                    show: false
                },
                rules: {
                    code: [{ required: true, message: '请输入88码', trigger: 'blur' }]
                },
                tabName: 'info',
                fixed: false,
                id: this.$route.params.projectKey || '' //续保，上一保单id
            }
        },
        mounted() {
            //2023.8.7增加回溯逻辑
            this.track_is_new = true;
            this.$nextTick(()=>{
                window.addEventListener("scroll", this.handleScroll);
                this.trackInit(); 
            })
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            bindWangdian () {
                if (!this.id) {
                    this.alert('确认必传参数')
                    return
                }
                if (!this.wangdian.form.single && !this.wangdian.form.singleO) {
                    this.toast('请选择其中一种险种', 'error')
                    return
                }
                this.wangdian.show = false
                let url = '/haierProduct.html#/company-group-employer-yunlifang/confirm/' + this.id;
                if (this.wangdian.form.single && this.wangdian.form.singleO) {
                    url = url + '?eariProductCode=' + this.wangdian.form.eariProductCode + '&eliProductCode=' + this.wangdian.form.eliProductCode
                } else if (!this.wangdian.form.single && this.wangdian.form.singleO) {
                    url = url + '?eliProductCode=' + this.wangdian.form.eliProductCode
                } else {
                    url = url + '?eariProductCode=' + this.wangdian.form.eariProductCode
                }
                this.$nextTick(() => {
                    this.stopRecord({
                        is_new: true
                    }).then(()=>{
                        window.location.href = url
                    })
                })
            },
            // 立即购买
            toBuy () {
                this.wangdian.form = {}
                this.wangdian.form.eariProductCode = 'ERECTION_ALL_1'
                this.wangdian.form.eliProductCode = 'EMP_LIABILITY_2'
                this.wangdian.show = true
            },
            // tab切换
            tabChange (val) {
                this.$refs[val].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                })
            },
            // 定位到伤残费率表位置
            toSC (key) {
                this.$refs[key].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                    block: "center"  // 上边框与视窗顶部平齐。默认值
                })
            },
            // 监听滚动
            handleScroll () {
                //获取滚动时的高度
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > this.$refs.tabs.offsetTop) {
                    this.fixed = true;
                } else {
                    this.fixed = false;
                }
            },
            // 清空表单校验
            handleReset (name) {
                this.$refs[name].resetFields()
            },
        }
    }
</script>
<style scoped lang="less">
    .employerTable {
        width: 100%;
        border-left: 1px solid #dfe6ec;
        border-bottom: 1px solid #dfe6ec;
        font-size: 14px;
        color: #1f2d3d;
        margin: 15px 0;

        th {
            height: 48px;
            background: #eef1f6;
            border-right: 1px solid #dfe6ec;
            padding: 0 10px;
        }

        td {
            border-right: 1px solid #dfe6ec;
            border-top: 1px solid #dfe6ec;
            height: 48px;
            padding-left: 10px;
        }

        .tip {
            font-size: 12px;
            padding-left: 70px;
        }
    }

    .main {
        margin-bottom: 30px;
    }

    .pb50 {
        padding-bottom: 50px;
    }

    .pt40 {
        padding-top: 40px;
    }

    .banner {
        cursor: pointer;
    }

    .banner-container {
        position: absolute;
        font-size: 14px;
        text-align: center;
        width: 510px;
        top: 80px;
        left: 0;
        right: 0;
        color: #fff;

        .notes {
            margin-top: 10px;
        }

        &-title {
            font-size: 32px;
            color: #333;
        }

        &-case {
            font-size: 24px;
            line-height: 2;
            color: #318af0;
        }

        &-sub {
            font-size: 14px;
            color: #555;
            margin-top: 30px;

            span {
                margin-right: 5px;
            }
        }

        &-desc {
            font-size: 18px;
        }

        &-input {
            width: 300px;
            margin: 20px auto 0;
        }

        &-btn {
            margin-top: 150px;
            margin-left: 150px;

            a {
                width: 240px;
            }
        }
    }

    .detail-title {
        font-size: 30px;
    }

    .detail-main {
        .center {
            font-size: 0;
        }

        &-title,
        &-text {
            // padding-left: 20px;
        }

        &-title {
            font-size: 18px;
        }

        &-text {
            line-height: 2;
        }
    }

    .tabs {
        display: block;
        height: 46px;

        &-container {
            padding: 10px 10px 0;
            background: #fff;
            height: 46px;
            overflow: hidden;
            position: relative;

            &-form {
                position: absolute;
                right: 10px;
                bottom: 5px;

                button {
                    display: inline-block;
                }
            }
        }

        .fixed {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            margin: auto;
            width: 1200px;
        }
    }

    .productDetail-table.sm {
        font-size: 13px;

        .fs16 {
            font-size: 16px;
        }

        td {
            padding: 8px;
        }
    }

    .hoverTr:hover {
        color: #fff;

        td {
            background: #77adf5;
        }

        .hoverDisabled {
            background: #fafafa;
            color: #333;
        }
    }

    .importantText {
        color: #77adf5;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerYunLiFang/Index.vue